<script>
	import { results } from "../stores.js";

	export let active;

	const resultsArray = Object.values($results).reverse();
</script>

<div class="results-indicator">
	{#each resultsArray as result}
		<div
			class="circle"
			class:active={active === result.id}
			style:background-color={result.color}
			style:border-color={result.color}
		/>
	{/each}
</div>

<style lang="scss">
	.results-indicator {
		display: flex;
		column-gap: 5px;
		padding-top: 2px;
	}
	.circle {
		width: 10px;
		height: 10px;
		border: 2.5px solid;
		// box-shadow: inset 0px 0px 2px rgba(0, 0, 0, 0.25);
		border-radius: 100%;
		transition: background-color 1s ease-in;
	}

	:not(.active) {
		background: none !important;
	}
</style>
